<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div class="ms-filter">
      <ms-form-filter
        :filters="filters"
        default-search="title"/>
    </div>
    <ms-grid
      :data="items"
      :columns="columns"
      :options="options"
      :pager="pager"
      :add-register="profile.role !== 'gerente_dealer'"
      @notFoundItem="newOpportunity">
      <template
        slot="title"
        slot-scope="{row}">
        <span
          class="btn-title"
          @click="onClickTitle(row)">{{ row.title }}</span>
      </template>
      <div
        slot="status"
        slot-scope="{row}"
        :class="{ 'success': row.status === 'Aceptada', 'danger': row.status === 'Rechazada', 'info': row.status === 'En Proceso' }"
        class="tag">
        {{ row.status }}
      </div>
      <div
        slot="phase"
        slot-scope="{row}"
        :class="{ 'proposal': row.phase === 'PROPOSAL', 'negotiation': row.phase === 'NEGOTIATION', 'closing': row.phase === 'CLOSING_OF_SALE', 'product': row.phase === 'PRODUCT_DELIVERY' }"
        class="tag">
        {{ parsePhase(row.phase) }}
      </div>
    </ms-grid>
    <create-opportunity
      v-if="showOpportunityPanel"
      :is-edit="isEdit"
      :old="oldOpportunity"
      @closeEdition = "closeEdit"/>
    <opportunity-detail
      v-if="showOpportunityDetailPanel"
      :current-opportunity="opportunity"/>
  </div>
</template>

<script>
import MsGrid from '@/modules/grid/ms-grid'
import MsFormFilter from '@/components/_shared/ms-form-filter'
import OpportunityDetail from '@/modules/customers/customers-opportunity-detail'
import CustomerGuards from '@/guards/customers.guards'
import CreateOpportunity from '@/views/app/opportunities/opportunities-create-view'
import moment from 'moment'
export default {
  name: 'CustomersOpportunityTable',
  components: {
    MsGrid,
    MsFormFilter,
    OpportunityDetail,
    CreateOpportunity
  },
  data () {
    return {
      fullscreenLoading: false,
      currentOpportunity: null,
      rangeDate: null,
      dateFilter: null,
      isRange: false,
      typeSales: null,
      status: null,
      opportunityItems: [],
      searchParams: {params: {}},
      filters: [
        {
          type: 'date',
          property: 'createdAt',
          props: {
            label: 'Fecha de creación'
          },
          queryFunction: function (val) {
            let _query
            if (!Array.isArray(val)) {
              _query = {
                'filters[whereBetween][createdAt]': val ? [moment(val).format('YYYY-MM-DD'), moment(val).add(1, 'day').format('YYYY-MM-DD')] : null
              }
            } else {
              _query = {
                'filters[whereBetween][createdAt]': [moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')]
              }
            }
            return _query
          }
        },
        {
          type: 'enum',
          property: 'type',
          props: {
            label: 'Tipo de compra:',
            options: [
              {
                label: 'Venta',
                value: 'SALE'
              },
              {
                label: 'Post Venta',
                value: 'AFTER_SALES'
              }
            ]
          }
        }
      ],
      columns: [
        {
          property: 'title',
          label: 'Título',
          align: 'center'
        },
        {
          property: 'type',
          label: 'Tipo',
          align: 'center',
          filter (value) {
            let values = {
              'SALE': 'Venta',
              'AFTER_SALES': 'Postventa'
            }
            return values[value] || value
          }
        },
        {
          property: 'status',
          label: 'Estatus',
          align: 'center'
        },
        {
          property: 'phase',
          label: 'Etapa',
          align: 'center'
        },
        {
          property: 'createdAt',
          label: 'Fecha de creacion',
          align: 'center',
          type: 'date'
        }
      ],
      options: {
        selectable: false,
        actions: [
          {
            label: 'Consultar',
            icon: 'icon-edit',
            onClick: async (row) => {
              await this.$store.dispatch('opportunities/get', { id: row.id })
              await this.$store.dispatch('app/toggleOpportunityDetailPanel')
            }
          },
          {
            label: 'Editar',
            icon: 'icon-edit',
            onClick: (row) => {
              this.onEdit(row)
              this.$store.dispatch('app/toggleOpportunityPanel')
            }
          }
        ]
      },
      isEdit: false,
      oldOpportunity: null
    }
  },
  computed: {
    items () {
      return this.$store.getters['opportunities/items']
    },
    pager () {
      return this.$store.getters['opportunities/pagination']
    },
    opportunity () {
      return this.$store.getters['opportunities/item']
    },
    showOpportunityDetailPanel () {
      return this.$store.getters['app/showOpportunityDetailPanel']
    },
    showOpportunityPanel () {
      return this.$store.getters['app/showOpportunityPanel']
    },
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  mounted () {
    if (this.profile.role === 'gerente_dealer') {
      this.options.actions.splice(1, 1)
    }
  },
  methods: {
    newOpportunity () {
      this.$store.dispatch('app/toggleOpportunityPanel')
    },
    onEdit (val) {
      this.oldOpportunity = val
      this.isEdit = true
      this.$store.dispatch('app/toggleTractorPanel')
    },
    closeEdit (val) {
      this.isEdit = val
    },
    onClickTitle (row) {
      this.$store.dispatch('opportunities/get', { id: row.id })
      this.$store.dispatch('app/toggleOpportunityDetailPanel')
    },
    onChangeStatus (val, row) {
      this.fullscreenLoading = true
      let clone = Object.assign({}, row)
      clone.status = val
      this.$store.dispatch('opportunities/save', clone)
        .then(response => {
          this.$message.success('La oportunidad ha sido actualizada con éxito')
        })
        .catch(e => {
          this.$message.error('La oportunidad no pudo ser actualizada')
        })
        .finally(() => {
          this.$store.dispatch('opportunities/query', {
            'filters[where][customerId][eq]': clone.customerId,
            limit: 1000
          })
            .finally(() => {
              this.fullscreenLoading = false
            })
        })
    },
    parsePhase (phase) {
      switch (phase) {
        case 'PROPOSAL':
          return 'Propuesta'
        case 'NEGOTIATION':
          return 'Negociación'
        case 'CLOSING_OF_SALE':
          return 'Cierre de venta'
        case 'PRODUCT_DELIVERY':
          return 'Entrega de producto'
        default:
          return ''
      }
    }
  },
  beforeRouteUpdate: CustomerGuards.onGetList('opportunities')
}
</script>

<style lang="scss" scoped>
  .tag {
    display: inline-block;
    @include font-primary(11px, regular);
    padding: 5px 12px;
    border-radius: 2px;
    color: #ffffff;
    &.danger{
      background-color: $--color-danger;
    }
    &.warning{
      background-color: $--color-warning;
    }
    &.success{
      background-color: $--color-success;
    }
    &.info{
      background-color: #409eff;
    }
    &.proposal {
      background-color: #409eff;
    }
    &.negotiation {
      background-color: #ffa142;
    }
    &.closing {
      background-color: #ffd042;
    }
    &.product {
      background-color: #30B122;
    }
  }
  .btn-title {
    cursor: pointer;
  }
  .ms-filter{
    margin: -20px -20px 0 -20px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/customers/customers-opportunity-table.vue